// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2NYG-","footerMenu":"style_footerMenu__2VCof","socialIcon":"style_socialIcon__RfQa7"};